import api from '../inits/axios';
import dsaLmsBaseApi from '../inits/dsaLmsBaseApi';
import fastagD2cBaseApi from '../inits/fastagD2cBaseApi';
import inventoryAPI from './inventoryServices';
import masterDataAPI from './masterDataServices';
import bulkUploadAPI from './bulkUploadServices';
import keyManagementAPI from './keyManagementServices';
import auditHistoryAPI from './auditHistoryServices';
import userManagementAPI from './userManagementServices';
import userManagementV2API from './userManagementV2Services';
import slotServiceAPI from './slotServices';
import scheduledTasksAPI from './scheduledTasksServices';
import dsaLmsAPI from './dsaLmsServices';
import fastagD2cServiceAPI from './fastagServices';
import carCleaningServiceAPI from './carCleaningServices';
import enbdRstlServiceAPI from './enbdRstlServices';
import couponServiceAPI from './couponServices';

const inventory = inventoryAPI(api);
const bulkupload = bulkUploadAPI(api);
const auditHistory = auditHistoryAPI(api);
const masterData = masterDataAPI(api);
const keyManagement = keyManagementAPI(api);
const userManagement = userManagementAPI(api);
const userManagementV2 = userManagementV2API(api);
const slotManagement = slotServiceAPI(api);
const scheduledTasks = scheduledTasksAPI(api);
const dsaLms = dsaLmsAPI(dsaLmsBaseApi);
const fastagD2c = fastagD2cServiceAPI(fastagD2cBaseApi);
const carCleaning = carCleaningServiceAPI(api);
const enbdRstl = enbdRstlServiceAPI(api);
const coupon = couponServiceAPI(api);

export {
  inventory as InventoryService,
  bulkupload as BulkUploadService,
  auditHistory as auditHistoryService,
  masterData as masterDataService,
  keyManagement as KeyManagementServices,
  userManagement as UserManagementService,
  userManagementV2 as UserManagementV2Service,
  slotManagement as SlotService,
  scheduledTasks as ScheduledTasksService,
  dsaLms as DsaLmsService,
  fastagD2c as fastagD2cService,
  carCleaning as carCleaningService,
  enbdRstl as EnbdRstlService,
  coupon as CouponService,
};
